import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const categoriesBaseEndpoint = ENDPOINTS.CATEGORY;

// Category API
export const categoryApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["categories"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCategories: builder.query({
        query: ({ page = 1, per_page = 10, search = "" } = {}) => ({
          url: `${categoriesBaseEndpoint}`,
          params: {
            page,
            per_page,
            ...(search && { search }),
          },
        }),
        transformResponse: (response) => response.data || response,
        providesTags: () => [{ type: "categories" }],
        keepUnusedDataFor:0
      }),
      getAllCategoriesPaginated: builder.query({
        query: ({ page = 1, per_page = 10, search = "" } = {}) => ({
          url: `${categoriesBaseEndpoint}paginated`,
          params: {
            page,
            per_page,
            ...(search && { search }),
          },
        }),
        transformResponse: (response) => response.data || response,
        providesTags: () => [{ type: "categories" }],
        keepUnusedDataFor:0
      }),

      addCategory: builder.mutation({
        query: (requestData) => ({
          url: `${categoriesBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "categories" }],
      }),
      updateCategory: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${categoriesBaseEndpoint}${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "categories" }],
      }),
      deleteCategory: builder.mutation({
        query: (id) => ({
          url: `${categoriesBaseEndpoint}${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "categories" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useGetAllCategoriesPaginatedQuery,
  useDeleteCategoryMutation,
} = categoryApi;
